import {
  //Core
  style,
  compose,
  space,
  width,
  colorStyle,
  textStyle,
  color,
  fontSize,
  fontFamily,
  textAlign,
  lineHeight,
  fontWeight,
  fontStyle,
  letterSpacing,
  display,
  maxWidth,
  minWidth,
  height,
  minHeight,
  maxHeight,
  size,
  verticalAlign,
  justifyItems,
  alignContent,
  justifyContent,
  alignItems,
  flexWrap,
  flexDirection,
  flex,
  justifySelf,
  alignSelf,
  order,
  flexBasis,
  gridGap,
  gridRowGap,
  gridColumnGap,
  gridColumn,
  gridRow,
  gridArea,
  gridAutoFlow,
  gridAutoRows,
  gridAutoColumns,
  gridTemplateRows,
  gridTemplateColumns,
  gridTemplateAreas,
  background,
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  backgroundRepeat,
  borders,
  borderRadius,
  boxShadow,
  opacity,
  overflow,
  position,
  zIndex,
  top,
  right,
  bottom,
  left
} from "styled-system";
///My Custom Style Utils
const fontVariant = style({
  prop: "fontVariant",
  cssProperty: "fontVariant"
});
const gridTemplate = style({
  //only needs cssProperty if it differs from prop
  prop: "gridTemplate"
});
const textShadow = style({
  //only needs cssProperty if it differs from prop
  prop: "textShadow"
});
const textDecoration = style({
  //only needs cssProperty if it differs from prop
  prop: "textDecoration"
});
const textTransform = style({
  //only needs cssProperty if it differs from prop
  prop: "textTransform"
});
const transition = style({
  //only needs cssProperty if it differs from prop
  prop: "transition"
});

const mixBlendMode = style({
  prop: "mixBlendMode",
  cssProperty: "mixBlendMode"
});
const backgroundBlendMode = style({
  prop: "backgroundBlendMode",
  cssProperty: "backgroundBlendMode"
});
const objectFit = style({
  //only needs cssProperty if it differs from prop
  prop: "objectFit"
});

const objectPosition = style({
  //only needs cssProperty if it differs from prop
  prop: "objectPosition"
});
const filter = style({
  //only needs cssProperty if it differs from prop
  prop: "filter",
  cssProperty: "filter"
});
const transform = style({
  //only needs cssProperty if it differs from prop
  prop: "transform",
  cssProperty: "transform"
});

export const baseStyleFunctions = compose(
  space,
  width,
  height,
  color,
  alignSelf,
  mixBlendMode,
  borderRadius,
  display,
  borders,
  position,
  top,
  bottom,
  opacity,
  left,
  transition,
  transform,
  filter,
  textAlign,
  fontFamily
);

export const styleFunctions = compose(
  space,
  width,
  colorStyle,
  color,
  textStyle,
  display,
  maxWidth,
  minWidth,
  borderRadius,
  height,
  maxHeight,
  minHeight,
  size,
  right,
  verticalAlign,
  justifySelf,
  alignSelf,
  gridArea,
  gridColumn,
  gridRow,
  background,
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  backgroundRepeat,
  backgroundBlendMode,
  mixBlendMode,
  borders,
  position,
  top,
  bottom,
  overflow,
  opacity,
  flexWrap,
  left,
  zIndex,
  boxShadow,
  transition,
  transform,
  filter,
  fontSize,
  fontFamily,
  textAlign,
  lineHeight,
  fontWeight,
  fontStyle,
  textTransform,
  letterSpacing,
  textDecoration,
  fontVariant,
  textShadow,
  gridGap,
  gridRowGap,
  gridColumnGap,
  gridAutoFlow,
  gridAutoRows,
  gridAutoColumns,
  gridTemplateRows,
  gridTemplateColumns,
  gridTemplateAreas,
  gridTemplate,
  justifyContent,
  justifyItems,
  alignContent,
  alignItems,
  justifyItems,
  alignContent,
  justifyContent,
  alignItems,
  flexWrap,
  flexDirection,
  flex,
  order,
  flexBasis,
  objectFit,
  objectPosition
);
